import BoldText from '@/components/BoldText';
import RegularText from '@/components/RegularText';
import { PATH } from '@/constants/path';
import { handleVisibleBanner, isOpenOrderInforBannerSelector } from '@/redux/slice/banner.slice';
import { Banner, Box, Button, Collapsible, InlineStack } from '@shopify/polaris';
import { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

interface OrderInforProps {
  currentPlan?: string;
  quota: number;
  used: number;
}

export const OrderInforBanner = ({ currentPlan, quota, used }: OrderInforProps) => {
  const isOpenInforBanner = useSelector(isOpenOrderInforBannerSelector);
  const [isOpenInfor, setIsOpenInfor] = useState<boolean>(isOpenInforBanner);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const usedOrderPercent = useMemo(() => (used / quota) * 100, [used, quota]);

  const NotificationBanner = () =>
    useMemo(() => {
      switch (true) {
        case usedOrderPercent < 50:
          return (
            <Banner
              onDismiss={() => {
                setIsOpenInfor(false);
                dispatch(handleVisibleBanner({ key: 'isOpenOrderInforBanner', value: false }));
              }}
            >
              <Box paddingInlineEnd={'200'}>
                <InlineStack>
                  <RegularText>
                    You have proceed {used}/{quota} orders per month in{' '}
                    <BoldText as="span">{currentPlan?.toUpperCase()}</BoldText> plan
                  </RegularText>
                  <Button onClick={() => navigate(PATH.PRICING)}>Increase limit</Button>
                </InlineStack>
              </Box>
            </Banner>
          );
        case usedOrderPercent < 100:
          return (
            <Banner
              onDismiss={() => {
                setIsOpenInfor(false);
                dispatch(handleVisibleBanner({ key: 'isOpenOrderInforBanner', value: false }));
              }}
              tone="warning"
            >
              <Box paddingInlineEnd={'200'}>
                <InlineStack>
                  <RegularText>
                    You have processed {used}/{quota} orders this month on the{' '}
                    <BoldText as="span">{currentPlan?.toUpperCase()}</BoldText> plan. Let’s increase your limit to continue using
                    the date picker.
                  </RegularText>
                  <Button onClick={() => navigate(PATH.PRICING)}>Increase limit</Button>
                </InlineStack>
              </Box>
            </Banner>
          );
        default:
          return (
            <Banner
              onDismiss={() => {
                setIsOpenInfor(false);
                dispatch(handleVisibleBanner({ key: 'isOpenOrderInforBanner', value: false }));
              }}
              tone="critical"
            >
              <Box paddingInlineEnd={'200'}>
                <InlineStack>
                  <RegularText>
                    You have reached the limit {used}/{quota} orders per month on the{' '}
                    <BoldText as="span">{currentPlan?.toUpperCase()}</BoldText> plan. Please upgrade now to avoid the widget from
                    stopping.
                  </RegularText>
                  <Button onClick={() => navigate(PATH.PRICING)}>Upgrade</Button>
                </InlineStack>
              </Box>
            </Banner>
          );
      }
    }, []);

  return (
    <Collapsible id={'order-infor-banner'} open={isOpenInfor}>
      <NotificationBanner />
    </Collapsible>
  );
};
